// licenseUrgency centralizes the "how alarming should this license look"
// decision so the banner and License page agree pixel-perfect.
//
// Levels (in escalating order):
//   normal  — Licensed with > 30 days remaining. No banner.
//   soon    — Licensed with 8–30 days remaining. Yellow tone.
//   urgent  — Licensed with 1–7 days remaining. Orange tone.
//   expired — Past expiry, or Mode is Expired/Unlicensed. Red tone.
//
// Pass the license context's { mode, daysRemaining } directly.
export function getLicenseUrgency({ mode, daysRemaining }) {
  if (mode === "expired" || mode === "unlicensed") return "expired";
  if (typeof daysRemaining !== "number") return "normal";
  if (daysRemaining <= 0) return "expired";
  if (daysRemaining <= 7) return "urgent";
  if (daysRemaining <= 30) return "soon";
  return "normal";
}

// urgencyLabel renders a short human-readable status for the banner / pill.
export function urgencyLabel({ mode, daysRemaining }) {
  if (mode === "unlicensed") return "License required";
  if (mode === "expired") {
    if (typeof daysRemaining === "number" && daysRemaining < 0) {
      return `Expired ${Math.abs(daysRemaining)} day${Math.abs(daysRemaining) === 1 ? "" : "s"} ago`;
    }
    return "License expired";
  }
  if (typeof daysRemaining !== "number") return "";
  if (daysRemaining <= 0) return "License expired";
  if (daysRemaining === 1) return "Expires in 1 day";
  return `Expires in ${daysRemaining} days`;
}
